import React, { useRef } from 'react';
var VeltNotificationsPanelSettingsHeader = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-settings-header", { ref: ref }, children));
};
export default VeltNotificationsPanelSettingsHeader;
